// extracted by mini-css-extract-plugin
module.exports = {"CSS_BREAKPOINT_LARGE":"1200px","CSS_BREAKPOINT_MEDIUM":"540px","CSS_BREAKPOINT_SMALL":"375px","Card":"Card_Card__27cJY","Header":"Card_Header__3-18w"};